// 默认文章模拟数据
export const defaultPostsData = [
  {
    id: 1,
    title: '春日清晨的第一缕阳光',
    excerpt: '当第一缕阳光透过窗帘的缝隙洒在书桌上，世界仿佛在这一刻苏醒。空气中弥漫着淡淡的咖啡香气，我坐在窗前，感受着这份宁静与美好...',
    content: `
      <h2>春日清晨的第一缕阳光</h2>
      
      <h3>一、清晨的仪式感</h3>
      <p>当第一缕阳光透过窗帘的缝隙洒在书桌上，世界仿佛在这一刻苏醒。空气中弥漫着淡淡的咖啡香气，我坐在窗前，感受着这份宁静与美好。</p>
      
      <p>每个清晨都是新的开始。我喜欢在早晨泡一杯咖啡，看着窗外的树木在晨光中慢慢苏醒。这种简单的仪式感让我的一天充满能量。</p>
      
      <p>鸟儿在枝头歌唱，远处的街道逐渐热闹起来。但在这个属于我自己的空间里，一切都显得那么平静而美好。</p>
      
      <blockquote>
        生活不是等待暴风雨过去，而是学会在雨中跳舞。
        <cite>—— 佚名</cite>
      </blockquote>
      
      <h3>二、思考与反思</h3>
      <p>早晨的宁静时光最适合思考。我会回顾昨天的收获，计划今天的行程，更重要的是，给自己一些反思的空间。</p>
      
      <p>在这个快节奏的时代，我们常常忽略了停下来思考的重要性。每天花一点时间与自己对话，了解自己的需求和感受。</p>
      
      <p>清晨的时光教会我，真正的幸福往往藏在这些平凡的瞬间里。</p>
      
      <h3>三、阳光的治愈力量</h3>
      <p>研究表明，早晨的阳光能够帮助我们调节生物钟，改善情绪。我常常会在窗边坐一会儿，让阳光温暖我的脸颊。</p>
      
      <p>这种简单的行为，却有着不可思议的治愈效果。它不仅温暖了身体，更温暖了心灵。</p>
      
      <h3>结语</h3>
      <p>珍惜每一个清晨，享受每一次阳光的拥抱。生活最美的风景，往往就在这些看似平凡的日常里。</p>
      
      <p>愿我们都能在忙碌的生活中，找到属于自己的宁静时刻。</p>
    `,
    date: '2024-03-15',
    category: '生活随笔',
    categoryColor: 'linear-gradient(45deg, #FFB8D9, #FF6B9D)',
    tags: ['春天', '阳光', '生活', '美好'],
    views: 2345,
    comments: 89,
    likes: 156,
    readTime: 5,
    author: {
      id: 1,
      name: '咖啡喵',
      role: '生活博主',
      avatar: '🐱',
      bio: '热爱生活，喜欢记录生活中的美好瞬间。相信每一天都有值得感恩的小确幸。'
    },
    featured: true,
    published: true,
    status: 'published', // 新增：文章状态（published/draft）
    createdAt: '2024-03-15T08:00:00Z',
    updatedAt: '2024-03-15T08:00:00Z'
  },
  {
    id: 2,
    title: '学习React Hooks深度解析与实践',
    excerpt: '深入探讨React Hooks的核心概念，分享在实际项目中的应用经验。从useState到useEffect，再到自定义Hook，一步步帮你掌握这个强大的功能...',
    content: `
      <h2>学习React Hooks深度解析与实践</h2>
      
      <h3>一、为什么需要Hooks？</h3>
      <p>在React Hooks出现之前，我们主要使用类组件来管理状态和生命周期。虽然类组件功能强大，但也存在一些问题：</p>
      <ul>
        <li>复杂的组件结构导致难以理解和维护</li>
        <li>生命周期方法分散了相关逻辑</li>
        <li>高阶组件和Render Props导致组件嵌套过深</li>
        <li>函数组件无法使用状态和生命周期</li>
      </ul>
      
      <p>Hooks的出现彻底改变了这一现状。它允许我们在函数组件中使用状态和其他React特性，让代码更加简洁和易于理解。</p>
      
      <h3>二、基础Hooks详解</h3>
      
      <h4>1. useState：状态管理</h4>
      <p><code>useState</code>是最基础的Hook，用于在函数组件中添加状态：</p>
      <pre><code>import React, { useState } from 'react';

function Counter() {
  const [count, setCount] = useState(0);
  
  return (
    <div>
      <p>You clicked {count} times</p>
      <button onClick={() => setCount(count + 1)}>
        Click me
      </button>
    </div>
  );
}</code></pre>
      
      <h4>2. useEffect：副作用处理</h4>
      <p><code>useEffect</code>用于处理组件中的副作用，如数据获取、DOM操作、订阅等：</p>
      <pre><code>import React, { useState, useEffect } from 'react';

function UserProfile({ userId }) {
  const [user, setUser] = useState(null);
  
  useEffect(() => {
    // 组件挂载或userId变化时执行
    fetchUser(userId).then(setUser);
    
    // 清理函数（可选）
    return () => {
      // 组件卸载时执行清理
    };
  }, [userId]); // 依赖数组
  
  return user ? <div>{user.name}</div> : <div>Loading...</div>;
}</code></pre>
      
      <h3>三、高级Hooks与自定义Hook</h3>
      
      <h4>1. useContext：跨组件数据传递</h4>
      <p>无需通过props逐层传递，直接获取Context中的数据。</p>
      
      <h4>2. useReducer：复杂状态管理</h4>
      <p>适合管理包含多个子值的复杂状态，类似于Redux的工作原理。</p>
      
      <h4>3. 自定义Hook：逻辑复用</h4>
      <p>自定义Hook让我们可以提取组件逻辑，实现代码复用：</p>
      <pre><code>import { useState, useEffect } from 'react';

// 自定义Hook：获取窗口大小
function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    window.addEventListener('resize', handleResize);
    
    // 清理事件监听
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return windowSize;
}

// 使用自定义Hook
function MyComponent() {
  const size = useWindowSize();
  return <div>Window size: {size.width} x {size.height}</div>;
}</code></pre>
      
      <h3>四、实践技巧与最佳实践</h3>
      
      <p><strong>1. Hooks使用规则：</strong></p>
      <ul>
        <li>只在React函数的最顶层调用Hooks</li>
        <li>只在React函数中调用Hooks</li>
      </ul>
      
      <p><strong>2. 性能优化：</strong></p>
      <ul>
        <li>使用<code>useMemo</code>缓存计算结果</li>
        <li>使用<code>useCallback</code>缓存函数</li>
        <li>合理设置<code>useEffect</code>的依赖数组</li>
      </ul>
      
      <p><strong>3. 常见模式：</strong></p>
      <ul>
        <li>数据获取模式</li>
        <li>表单处理模式</li>
        <li>定时器管理</li>
        <li>事件订阅与清理</li>
      </ul>
      
      <h3>五、实战项目示例</h3>
      
      <p>让我们创建一个待办事项应用，展示Hooks的实际应用：</p>
      <pre><code>import React, { useState, useReducer, useEffect } from 'react';

// 初始状态
const initialState = {
  todos: [],
  filter: 'all',
};

// Reducer函数
function todoReducer(state, action) {
  switch (action.type) {
    case 'ADD_TODO':
      return {
        ...state,
        todos: [...state.todos, {
          id: Date.now(),
          text: action.text,
          completed: false,
        }],
      };
    case 'TOGGLE_TODO':
      return {
        ...state,
        todos: state.todos.map(todo =>
          todo.id === action.id
            ? { ...todo, completed: !todo.completed }
            : todo
        ),
      };
    case 'SET_FILTER':
      return { ...state, filter: action.filter };
    default:
      return state;
  }
}

function TodoApp() {
  const [state, dispatch] = useReducer(todoReducer, initialState);
  const [input, setInput] = useState('');
  
  // 过滤待办事项
  const filteredTodos = state.todos.filter(todo => {
    if (state.filter === 'active') return !todo.completed;
    if (state.filter === 'completed') return todo.completed;
    return true;
  });
  
  // 保存到localStorage
  useEffect(() => {
    localStorage.setItem('todos', JSON.stringify(state.todos));
  }, [state.todos]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (input.trim()) {
      dispatch({ type: 'ADD_TODO', text: input });
      setInput('');
    }
  };
  
  return (
    <div className="todo-app">
      <h2>待办事项 ({filteredTodos.length})</h2>
      
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="添加新的待办事项..."
        />
        <button type="submit">添加</button>
      </form>
      
      <div className="filter-buttons">
        {['all', 'active', 'completed'].map(filter => (
          <button
            key={filter}
            onClick={() => dispatch({ type: 'SET_FILTER', filter })}
            className={state.filter === filter ? 'active' : ''}
          >
            {filter === 'all' ? '全部' : filter === 'active' ? '未完成' : '已完成'}
          </button>
        ))}
      </div>
      
      <ul className="todo-list">
        {filteredTodos.map(todo => (
          <li key={todo.id} className={todo.completed ? 'completed' : ''}>
            <span onClick={() => dispatch({ type: 'TOGGLE_TODO', id: todo.id })}>
              {todo.text}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}</code></pre>
      
      <h3>六、总结与展望</h3>
      
      <p>React Hooks代表了React未来的发展方向，它们让函数组件变得真正强大和实用。通过Hooks，我们可以：</p>
      
      <ul>
        <li>编写更简洁、更易于理解的代码</li>
        <li>更好地组织和复用组件逻辑</li>
        <li>减少对类组件的依赖</li>
        <li>创建更加模块化和可测试的代码</li>
      </ul>
      
      <blockquote>
        Hooks不是要取代你现有的知识，它们只是为你已经知道的React概念提供了一个更直接的API。
        <cite>—— React官方文档</cite>
      </blockquote>
      
      <p>随着React的不断发展，Hooks将会成为React开发的主流模式。现在就开始学习和使用Hooks，将为你的React开发生涯带来巨大的优势。</p>
      
      <p><strong>学习资源推荐：</strong></p>
      <ul>
        <li>React官方文档的Hooks章节</li>
        <li>React Hooks FAQ</li>
        <li>useHooks.com（优质自定义Hook集合）</li>
        <li>React Conf相关演讲视频</li>
      </ul>
      
      <p>希望这篇文章能帮助你深入理解React Hooks，并在实际项目中灵活运用。祝你在React的学习道路上越走越远！</p>
    `,
    date: '2024-03-10',
    category: '技术分享',
    categoryColor: 'linear-gradient(45deg, #8FD3FF, #3AA8FF)',
    tags: ['React', 'Hooks', '前端', 'JavaScript'],
    views: 4567,
    comments: 156,
    likes: 289,
    readTime: 8,
    author: {
      id: 2,
      name: '代码狗',
      role: '前端工程师',
      avatar: '🐶',
      bio: '技术极客，热爱开源和新技术。负责维护博客的技术架构和用户体验优化。'
    },
    featured: true,
    published: true,
    status: 'published', // 新增：文章状态
    createdAt: '2024-03-10T10:30:00Z',
    updatedAt: '2024-03-10T10:30:00Z'
  },
  {
    id: 3,
    title: '《百年孤独》中的人性与命运',
    excerpt: '马尔克斯笔下的马孔多小镇，像一面镜子映照出人类的孤独与命运的轮回。在布恩迪亚家族的兴衰中，我们看到的不只是故事，更是生命的哲学...',
    content: `
      <h2>《百年孤独》中的人性与命运</h2>
      
      <h3>一、开篇：马孔多的诞生</h3>
      <p>加西亚·马尔克斯的《百年孤独》开篇就是一句震撼人心的话：</p>
      <blockquote>
        "多年以后，面对行刑队，奥雷里亚诺·布恩迪亚上校将会回想起父亲带他去见识冰块的那个遥远的下午。"
      </blockquote>
      
      <p>这句话不仅奠定了小说的叙事基调，更暗示了整个布恩迪亚家族命运的轮回与宿命感。马孔多，这个虚构的小镇，从一开始就笼罩在神秘与预兆之中。</p>
      
      <h3>二、人物群像：孤独的宿命</h3>
      
      <h4>1. 何塞·阿尔卡蒂奥·布恩迪亚：梦想与疯狂</h4>
      <p>家族的创始人，一个充满好奇心和探索精神的发明家。他的悲剧在于，永远无法在马孔多实现他的科学梦想，最终在栗树下孤独终老。</p>
      
      <h4>2. 奥雷里亚诺·布恩迪亚上校：战争与虚无</h4>
      <p>发动了32场起义，躲过了14次暗杀、73次埋伏和一次枪决。然而，战争胜利后他却找不到意义，只能在作坊里制作小金鱼，做了又熔，熔了又做。</p>
      
      <h4>3. 乌尔苏拉·伊瓜兰：坚韧与守护</h4>
      <p>家族的灵魂人物，见证了七代人的兴衰。她的坚韧与务实，在某种程度上延缓了家族的衰败，却无法改变最终的命运。</p>
      
      <h4>4. 蕾梅黛丝：纯真与超脱</h4>
      <p>"最美的人"，她的美不染尘埃，最终抓住床单飞升而去，象征了世俗无法理解的纯粹与超脱。</p>
      
      <h3>三、主题解析：孤独的多重维度</h3>
      
      <p><strong>1. 个体孤独：</strong>每个家族成员都有自己独特的孤独方式，无论是何塞的疯狂研究、奥雷里亚诺的战争、阿玛兰妲的缝纫，还是奥雷里亚诺第二的放纵。</p>
      
      <p><strong>2. 家族孤独：</strong>布恩迪亚家族就像一个孤岛，与外界保持着微妙的距离。他们拥有共同的命运，却无法真正理解彼此。</p>
      
      <p><strong>3. 历史孤独：</strong>马孔多的历史，从香蕉公司的剥削到罢工屠杀，反映了拉丁美洲被遗忘的历史和被边缘化的命运。</p>
      
      <p><strong>4. 人类孤独：</strong>最终，孤独不再只是布恩迪亚家族的特质，而是人类的普遍处境。我们都在寻找连接，却难以逃脱孤独的本质。</p>
      
      <h3>四、命运轮回：重复的宿命</h3>
      
      <p>小说中充满了惊人的重复：</p>
      
      <ul>
        <li>名字的重复：阿尔卡蒂奥和奥雷里亚诺交替出现</li>
        <li>行为的重复：乱伦、战争、研究、放纵</li>
        <li>命运的重复：每个人的结局似乎早已注定</li>
      </ul>
      
      <p>这种重复不是简单的复制，而是在细微变化中的螺旋式重复，最终导向无可避免的衰败。</p>
      
      <h3>五、时间观：线性与循环的辩证</h3>
      
      <p>马尔克斯打破了传统线性叙事，创造了一种循环的时间观。在《百年孤独》中：</p>
      
      <ul>
        <li>过去、现在、未来交织在一起</li>
        <li>预言与回忆模糊了时间的界限</li>
        <li>家族历史在不断重复中演进</li>
      </ul>
      
      <p>这种时间观反映了拉丁美洲的集体记忆：历史似乎总在重复，创伤难以愈合，未来充满不确定性。</p>
      
      <h3>六、魔幻现实主义：现实与超现实的交融</h3>
      
      <p>《百年孤独》是魔幻现实主义的代表作，其中最著名的魔幻元素包括：</p>
      
      <ul>
        <li>蕾梅黛丝抓着床单飞升</li>
        <li>黄色蝴蝶总在梅尔基亚德斯出现时飞舞</li>
        <li>何塞在栗树下死去后，天上下起了黄花雨</li>
        <li>阿玛兰妲预知自己的死亡时间</li>
      </ul>
      
      <p>这些魔幻元素不是简单的幻想，而是对现实更深层次的揭示。在马尔克斯看来，拉美大陆的现实本身就充满了魔幻色彩。</p>
      
      <h3>七、历史隐喻：拉丁美洲的缩影</h3>
      
      <p>马孔多的历史，就是拉丁美洲历史的隐喻：</p>
      
      <table class="history-table">
        <tr>
          <th>马孔多事件</th>
          <th>历史对应</th>
        </tr>
        <tr>
          <td>吉普赛人的到来</td>
          <td>欧洲文明的传入</td>
        </tr>
        <tr>
          <td>香蕉公司的剥削</td>
          <td>外国资本的掠夺</td>
        </tr>
        <tr>
          <td>罢工与屠杀</td>
          <td>拉美的独裁与镇压</td>
        </tr>
        <tr>
          <td>香蕉公司撤走后的健忘症</td>
          <td>历史的被遗忘与被篡改</td>
        </tr>
      </table>
      
      <h3>八、结尾的启示：遗忘与毁灭</h3>
      
      <p>小说的结尾令人震撼：</p>
      <blockquote>
        "这手稿上所写的事情过去不曾，将来也永远不会重复，因为命中注定要一百年处于孤独的世家绝不会有出现在世上的第二次机会。"
      </blockquote>
      
      <p>羊皮卷被破译的那一刻，马孔多被飓风抹去。这个结尾有多重解读：</p>
      
      <ol>
        <li><strong>宿命的终结：</strong>布恩迪亚家族百年的孤独轮回终于结束</li>
        <li><strong>历史的警示：</strong>如果不从历史中吸取教训，终将重蹈覆辙</li>
        <li><strong>文学的力量：</strong>唯有通过书写和记忆，才能对抗遗忘</li>
        <li><strong>希望的微光：</strong>彻底的毁灭也可能是新生的开始</li>
      </ol>
      
      <h3>九、现实意义：我们与孤独的对话</h3>
      
      <p>阅读《百年孤独》不仅是一次文学体验，更是一次自我审视的机会：</p>
      
      <ul>
        <li><strong>面对孤独：</strong>我们如何与自己的孤独相处？</li>
        <li><strong>理解命运：</strong>个人的选择与命运的必然之间是什么关系？</li>
        <li><strong>认识历史：</strong>我们如何理解个人与家族、民族历史的关系？</li>
        <li><strong>寻找意义：</strong>在重复与无常中，如何找到生命的意义？</li>
      </ul>
      
      <p>马尔克斯没有给出简单的答案，但他通过布恩迪亚家族的故事，让我们看到了人类处境的复杂与深刻。</p>
      
      <h3>十、结语：永恒的孤独，永恒的人性</h3>
      
      <p>《百年孤独》的伟大之处在于，它不仅讲述了一个家族的百年兴衰，更探讨了人类的永恒主题：</p>
      
      <ul>
        <li>爱与孤独的辩证</li>
        <li>记忆与遗忘的对抗</li>
        <li>个体与历史的纠缠</li>
        <li>现实与梦想的距离</li>
      </ul>
      
      <p>百年过去了，布恩迪亚家族的孤独似乎仍在某个角落回响。而每个读者，都能在这个故事中找到自己的影子。</p>
      
      <blockquote>
        孤独的反面不是在一起，而是理解与被理解。
        <cite>—— 对《百年孤独》的现代解读</cite>
      </blockquote>
      
      <p>愿我们在理解孤独的过程中，找到连接的可能；在认识命运的限制中，发现自由的空间。</p>
    `,
    date: '2024-03-05',
    category: '读书笔记',
    categoryColor: 'linear-gradient(45deg, #FFD166, #FF9A3D)',
    tags: ['读书', '马尔克斯', '文学', '哲学'],
    views: 1890,
    comments: 45,
    likes: 128,
    readTime: 6,
    author: {
      id: 3,
      name: '书虫君',
      role: '文学爱好者',
      avatar: '📚',
      bio: '热爱阅读，喜欢分享读书心得和感悟。相信文字有力量，书籍是通往世界的窗口。'
    },
    featured: false,
    published: true,
    status: 'published', // 新增：文章状态
    createdAt: '2024-03-05T14:20:00Z',
    updatedAt: '2024-03-05T14:20:00Z'
  },
  {
    id: 4,
    title: '京都红叶季的完美旅行指南',
    excerpt: '秋天是京都最美的季节。从清水寺到岚山，从哲学之道到金阁寺，这份超详细旅行攻略带你领略红叶与古建筑的完美结合...',
    content: `
      <h2>京都红叶季的完美旅行指南</h2>
      
      <div class="travel-intro">
        <p>秋天是京都最美的季节。当枫叶由绿转红，古都京都便披上了一层绚烂的锦衣。金黄色的银杏、火红的枫叶与古老的寺庙相映成趣，构成了一幅幅令人心醉的画面。</p>
        
        <p>本指南将带你深度探索京都红叶季，从经典景点到隐藏秘境，从摄影技巧到美食推荐，为你打造一次难忘的京都秋日之旅。</p>
      </div>
      
      <h3>一、最佳观赏时间</h3>
      
      <p>京都的红叶观赏期通常从<strong>11月中旬持续到12月上旬</strong>，但具体时间每年略有不同：</p>
      
      <ul>
        <li><strong>11月上旬：</strong>高海拔地区（如高雄、贵船）开始变色</li>
        <li><strong>11月中旬：</strong>市区和主要景点进入最佳观赏期</li>
        <li><strong>11月下旬：</strong>红叶达到最盛，夜枫观赏开始</li>
        <li><strong>12月上旬：</strong>红叶开始凋落，别有一番风味</li>
      </ul>
      
      <div class="travel-tip">
        <p><strong>📅 旅行小贴士：</strong>建议关注日本气象厅的红叶前线预报，精准安排行程。</p>
      </div>
      
      <h3>二、必去红叶名所TOP 10</h3>
      
      <h4>1. 清水寺（Kiyomizu-dera）</h4>
      <p><strong>特色：</strong>京都最具代表性的红叶景点，从清水舞台俯瞰漫山红叶的震撼景象。</p>
      <p><strong>最佳拍摄点：</strong>清水舞台、奥之院、仁王门</p>
      <p><strong>开放时间：</strong>6:00-18:00（夜枫期间延长至21:00）</p>
      <p><strong>门票：</strong>日间400日元，夜枫400日元</p>
      
      <h4>2. 岚山（Arashiyama）</h4>
      <p><strong>特色：</strong>乘嵯峨野小火车穿越红叶隧道，漫步竹林小径，体验渡月桥的秋色。</p>
      <p><strong>最佳拍摄点：</strong>渡月桥、竹林小径、常寂光寺</p>
      <p><strong>小火车：</strong>建议提前网上预订，选择靠窗座位</p>
      
      <h4>3. 东福寺（Tofuku-ji）</h4>
      <p><strong>特色：</strong>京都规模最大的红叶名所，通天桥的红叶隧道令人叹为观止。</p>
      <p><strong>最佳时间：</strong>11月下旬，枫叶最盛</p>
      <p><strong>门票：</strong>400日元（通天桥+开山堂）</p>
      
      <h4>4. 永观堂（Eikan-do）</h4>
      <p><strong>别名：</strong>"红叶的永观堂"，夜枫尤其美丽</p>
      <p><strong>特色：</strong>池泉回游式庭园，红叶倒映水中，美不胜收</p>
      <p><strong>夜枫时间：</strong>17:30-21:00（最后入场20:30）</p>
      
      <h4>5. 哲学之道（Philosopher's Path）</h4>
      <p><strong>特色：</strong>约2公里的石板小路，两旁种满枫树和樱树，秋季红黄交错。</p>
      <p><strong>最佳时段：</strong>清晨或傍晚，避开人流高峰</p>
      <p><strong>沿途景点：</strong>银阁寺、法然院、熊野若王子神社</p>
      
      <h4>6. 金阁寺（Kinkaku-ji）</h4>
      <p><strong>特色：</strong>金阁与红叶的黄金组合，倒映在镜湖池中，分外耀眼。</p>
      <p><strong>最佳时间：</strong>早晨阳光照射金阁时</p>
      <p><strong>门票：</strong>400日元</p>
      
      <h4>7. 南禅寺（Nanzen-ji）</h4>
      <p><strong>特色：</strong>宏伟的三门、水路阁与红叶的完美结合，富有历史感。</p>
      <p><strong>隐藏景点：</strong>天授庵的夜枫别具一格</p>
      
      <h4>8. 高山寺（Kozan-ji）</h4>
      <p><strong>特色：</strong>世界遗产，相对小众，红叶与古寺相得益彰。</p>
      <p><strong>交通：</strong>乘JR巴士至"高雄"站下车</p>
      
      <h4>9. 贵船神社（Kifune-jinja）</h4>
      <p><strong>特色：</strong>山间秘境，参道两侧的红色灯笼与红叶交相辉映。</p>
      <p><strong>特别体验：</strong>川床料理（需预约）</p>
      
      <h4>10. 醍醐寺（Daigo-ji）</h4>
      <p><strong>特色：</strong>丰臣秀吉举办"醍醐花见"之地，红叶规模宏大。</p>
      <p><strong>最佳区域：</strong>三宝院的庭园</p>
      
      <h3>三、红叶季摄影技巧</h3>
      
      <div class="photography-tips">
        <h4>📸 设备准备</h4>
        <ul>
          <li><strong>相机：</strong>单反或微单，搭配变焦镜头（24-70mm或70-200mm）</li>
          <li><strong>三脚架：</strong>夜枫拍摄必备</li>
          <li><strong>偏振镜：</strong>消除反光，让红叶颜色更饱和</li>
          <li><strong>备用电池：</strong>低温下电池耗电快</li>
        </ul>
        
        <h4>🎨 拍摄技巧</h4>
        <ul>
          <li><strong>光线利用：</strong>早晨的侧光和傍晚的逆光最能表现红叶的质感</li>
          <li><strong>构图技巧：</strong>利用寺庙建筑作为框架，突出红叶主体</li>
          <li><strong>水景拍摄：</strong>捕捉红叶在水中的倒影，增加画面层次</li>
          <li><strong>人物点缀：</strong>穿和服的人物可以为红叶场景增添故事感</li>
        </ul>
        
        <h4>🌙 夜枫拍摄</h4>
        <ul>
          <li>使用三脚架，ISO控制在100-400</li>
          <li>小光圈（f/8-f/16）获得更大景深</li>
          <li>快门速度1-5秒，捕捉灯光下的红叶细节</li>
          <li>白平衡设为"钨丝灯"或自定义，避免偏色</li>
        </ul>
      </div>
      
      <h3>四、5日深度游行程推荐</h3>
      
      <div class="itinerary">
        <h4>Day 1：东山地区</h4>
        <ul>
          <li>上午：清水寺 → 三年坂二年坂</li>
          <li>中午：衹园地区午餐（推荐汤豆腐料理）</li>
          <li>下午：高台寺 → 圆山公园 → 八坂神社</li>
          <li>晚上：永观堂夜枫</li>
        </ul>
        
        <h4>Day 2：岚山地区</h4>
        <ul>
          <li>上午：嵯峨野小火车（龟冈→岚山）</li>
          <li>中午：岚山豆腐宴</li>
          <li>下午：竹林小径 → 天龙寺 → 渡月桥</li>
          <li>傍晚：常寂光寺赏枫</li>
        </ul>
        
        <h4>Day 3：哲学之道沿线</h4>
        <ul>
          <li>上午：银阁寺 → 哲学之道漫步</li>
          <li>中午：法然院附近荞麦面店</li>
          <li>下午：南禅寺 → 蹴上倾斜铁道</li>
          <li>晚上：先斗町晚餐，鸭川散步</li>
        </ul>
        
        <h4>Day 4：高雄&贵船秘境</h4>
        <ul>
          <li>上午：高山寺 → 神护寺</li>
          <li>中午：高雄川床料理</li>
          <li>下午：贵船神社 → 鞍马寺</li>
          <li>晚上：返回市区，锦市场晚餐</li>
        </ul>
        
        <h4>Day 5：经典寺庙巡礼</h4>
        <ul>
          <li>上午：东福寺 → 伏见稻荷大社（千本鸟居）</li>
          <li>中午：伏见区清酒品尝</li>
          <li>下午：醍醐寺 → 平等院（宇治）</li>
          <li>晚上：京都站夜景，购买伴手礼</li>
        </ul>
      </div>
      
      <h3>五、红叶季美食推荐</h3>
      
      <div class="food-recommendations">
        <h4>🍁 秋季限定美食</h4>
        <ul>
          <li><strong>红叶馒头：</strong>枫叶形状的和果子，各寺庙都有售卖</li>
          <li><strong>秋刀鱼料理：</strong>秋季正是秋刀鱼最肥美的季节</li>
          <li><strong>松茸饭：</strong>秋季的奢侈美味，香气独特</li>
          <li><strong>柿子：</strong>京都丹波产的柿子甜美多汁</li>
          <li><strong>栗子甜品：</strong>蒙布朗、栗子羊羹等</li>
        </ul>
        
        <h4>🏮 推荐餐厅</h4>
        <ul>
          <li><strong>顺正：</strong>南禅寺附近的汤豆腐名店</li>
          <li><strong>奥丹：</strong>300年历史的豆腐料理老铺</li>
          <li><strong>广川：</strong>岚山米其林一星鳗鱼饭</li>
          <li><strong>瓢亭：</strong>米其林三星，早餐尤为有名</li>
        </ul>
      </div>
      
      <h3>六、实用旅行贴士</h3>
      
      <div class="practical-tips">
        <h4>🚌 交通建议</h4>
        <ul>
          <li>购买"京都巴士一日券"（600日元），无限次乘坐市巴士</li>
          <li>红叶季景点拥挤，建议早出晚归，避开高峰</li>
          <li>岚山小火车、高级餐厅需提前预订</li>
          <li>下载"乘换案内"APP，实时查询交通信息</li>
        </ul>
        
        <h4>🏨 住宿推荐</h4>
        <ul>
          <li><strong>东山地区：</strong>靠近景点，交通便利</li>
          <li><strong>四条乌丸：</strong>市中心，购物餐饮方便</li>
          <li><strong>京都站周边：</strong>交通枢纽，适合作为旅行基地</li>
          <li><strong>町屋民宿：</strong>体验传统日式住宿</li>
        </ul>
        
        <h4>🎎 文化礼仪</h4>
        <ul>
          <li>寺庙内保持安静，拍照时关闭闪光灯</li>
          <li>脱鞋进入寺庙建筑，自备袋子装鞋</li>
          <li>排队拍照，礼让他人</li>
          <li>垃圾分类，保持环境整洁</li>
        </ul>
        
        <h4>🧳 行李准备</h4>
        <ul>
          <li>11月京都气温5-15°C，需准备保暖衣物</li>
          <li>舒适的运动鞋（每天步行2万步以上）</li>
          <li>雨具（秋季可能有雨）</li>
          <li>便携坐垫（寺院参拜时使用）</li>
        </ul>
      </div>
      
      <h3>七、隐藏秘境：避开人潮的小众景点</h3>
      
      <div class="hidden-gems">
        <h4>1. 源光庵（Genko-an）</h4>
        <p>以"顿悟之窗"和"迷惘之窗"闻名，秋季庭院红叶别具禅意。</p>
        
        <h4>2. 正传寺（Shoden-ji）</h4>
        <p>枯山水庭园与远山红叶形成绝妙构图，摄影爱好者的秘密基地。</p>
        
        <h4>3. 诗仙堂（Shisen-do）</h4>
        <p>文人别墅改建的寺庙，红叶与书院造建筑相得益彰。</p>
        
        <h4>4. 实相院（Jikko-in）</h4>
        <p>"床红叶"奇观，红叶直接落在榻榻米上，形成天然红毯。</p>
        
        <h4>5. 大原三千院（Sanzen-in）</h4>
        <p>远离市区，苔庭与红叶的组合宁静而神圣。</p>
      </div>
      
      <h3>八、红叶季特别体验</h3>
      
      <div class="special-experiences">
        <h4>🎎 和服体验</h4>
        <p>穿着和服漫步红叶中，拍照效果极佳。推荐冈本、梦馆等租赁店。</p>
        
        <h4>🍵 茶道体验</h4>
        <p>在古寺中体验正宗的日本茶道，品味抹茶与和果子的雅趣。</p>
        
        <h4>🚣 保津川游船</h4>
        <p>从龟冈乘船顺流而下至岚山，两岸红叶如画。</p>
        
                <h4>🏮 夜间特别参拜</h4>
        <p>多个寺庙在红叶季开放夜间参拜，灯光下的红叶如梦如幻。</p>
      </div>
      
      <h3>九、预算参考（5天4晚）</h3>
      
      <table class="budget-table">
        <tr>
          <<th>项目</</th>
          <<th>经济型</</th>
          <<th>舒适型</</th>
          <<th>豪华型</</th>
        </tr>
        <tr>
          <td>机票（往返）</td>
          <td>2,500-3,500元</td>
          <td>3,500-5,000元</td>
          <td>5,000元以上</td>
        </tr>
        <tr>
          <td>住宿（4晚）</td>
          <td>1,200-2,000元</td>
          <td>2,000-4,000元</td>
          <td>4,000元以上</td>
        </tr>
        <tr>
          <td>餐饮（5天）</td>
          <td>1,000-1,500元</td>
          <td>1,500-2,500元</td>
          <td>2,500元以上</td>
        </tr>
        <tr>
          <td>交通门票</td>
          <td>500-800元</td>
          <td>800-1,200元</td>
          <td>1,200元以上</td>
        </tr>
        <tr>
          <td>购物体验</td>
          <td>500-1,000元</td>
          <td>1,000-2,000元</td>
          <td>2,000元以上</td>
        </tr>
        <tr>
          <td><strong>总计</strong></td>
          <td><strong>5,700-8,800元</strong></td>
          <td><strong>8,800-14,700元</strong></td>
          <td><strong>14,700元以上</strong></td>
        </tr>
      </table>
      
      <h3>十、结语：京都之秋，一生必见的风景</h3>
      
      <p>京都的红叶季，是一年中最美的时刻。这不仅是色彩的盛宴，更是与历史、文化、自然的深度对话。</p>
      
      <blockquote>
        春赏樱花，秋观红叶。京都的美，在四季的轮回中绽放不同的光彩。而红叶季的京都，就像一位盛装的古典美人，将千年的风华凝聚在那一抹红色之中。
      </blockquote>
      
      <p>无论你是第一次到访京都，还是多次重游，红叶季的京都总能带给你新的感动和发现。</p>
      
      <p>愿这份指南能帮助你规划一次完美的京都红叶之旅。在枫叶飘落的季节，遇见最美的京都，也遇见更好的自己。</p>
      
      <div class="closing-note">
        <p><strong>📝 最后提醒：</strong></p>
        <ul>
          <li>提前3-6个月预订机票和住宿</li>
          <li>购买旅行保险，保障出行安全</li>
          <li>学习基本的日语问候语</li>
          <li>带上开放的心态，享受旅途中的每一刻</li>
        </ul>
        
        <p>京都的红叶，等了你一整年。现在，是时候出发了。</p>
        <p>旅途愉快！🍁✨</p>
      </div>
    `,
    date: '2024-02-28',
    category: '旅行日记',
    categoryColor: 'linear-gradient(45deg, #A8E6CF, #4DB5A0)',
    tags: ['旅行', '日本', '京都', '红叶'],
    views: 3120,
    comments: 78,
    likes: 234,
    readTime: 7,
    author: {
      id: 4,
      name: '旅行猫',
      role: '旅行摄影师',
      avatar: '✈️',
      bio: '热爱旅行，喜欢用镜头记录世界的美好。已走过30+国家，分享旅行故事和实用攻略。'
    },
    featured: true,
    published: true,
    status: 'published', // 新增：文章状态
    createdAt: '2024-02-28T09:15:00Z',
    updatedAt: '2024-02-28T09:15:00Z'
  },
  // 新增：草稿文章示例
  {
    id: 5,
    title: '狗狗训练新手指南（未完成）',
    excerpt: '整理狗狗基础训练的几个关键步骤，从定点如厕到随行训练...',
    content: '<h2>狗狗训练新手指南</h2><p>1. 定点如厕训练：...</p><p>2. 随行训练：...</p>',
    date: '2024-03-20',
    category: '宠物养护',
    categoryColor: 'linear-gradient(45deg, #FFB8D9, #FF6B9D)',
    tags: ['狗狗', '训练', '新手'],
    views: 0,
    comments: 0,
    likes: 0,
    readTime: 5,
    author: {
      id: 1,
      name: '咖啡喵',
      role: '生活博主',
      avatar: '🐱',
      bio: '热爱生活，喜欢记录生活中的美好瞬间。相信每一天都有值得感恩的小确幸。'
    },
    featured: false,
    published: false,
    status: 'draft', // 新增：草稿状态
    createdAt: '2024-03-20T14:30:00Z',
    updatedAt: '2024-03-20T15:10:00Z'
  }
];

// 模拟博客数据 + 模拟接口方法
export const MOCK_POSTS = [
  {
    id: 1,
    title: '我的第一篇狗狗主题博客',
    excerpt: '分享和狗狗相处的日常，记录它的可爱瞬间～',
    category: '生活随笔',
    categoryColor: 'linear-gradient(45deg, #FFB8D9, #FF6B9D)',
    date: '2026-01-01',
    readTime: 8,
    featured: true,
    tags: ['狗狗', '日常', '宠物'],
    author: {
      name: '铲屎官小李',
      role: '宠物博主',
      avatar: '🐶'
    },
    likes: 128,
    views: 2568,
    comments: 36,
    content: '（完整博客内容）',
    status: 'published', // 新增：文章状态
    createdAt: '2026-01-01T10:00:00Z',
    updatedAt: '2026-01-01T10:00:00Z'
  },
  {
    id: 2,
    title: '狗狗饮食攻略：新手必看',
    excerpt: '整理了狗狗不同年龄段的饮食注意事项，避坑指南！',
    category: '生活随笔',
    categoryColor: 'linear-gradient(45deg, #FFD166, #FF8C00)',
    date: '2026-01-05',
    readTime: 10,
    featured: false,
    tags: ['狗狗', '饮食', '新手'],
    author: {
      name: '铲屎官小李',
      role: '宠物博主',
      avatar: '🐶'
    },
    likes: 89,
    views: 1890,
    comments: 24,
    content: '（完整博客内容）',
    status: 'published', // 新增：文章状态
    createdAt: '2026-01-05T14:30:00Z',
    updatedAt: '2026-01-05T14:30:00Z'
  },
  // 新增：草稿文章示例
  {
    id: 3,
    title: '狗狗行为解读（草稿）',
    excerpt: '分析狗狗常见行为背后的含义，比如摇尾巴、舔人等...',
    category: '宠物知识',
    categoryColor: 'linear-gradient(45deg, #8FD3FF, #3AA8FF)',
    date: '2026-01-10',
    readTime: 6,
    featured: false,
    tags: ['狗狗', '行为', '知识'],
    author: {
      name: '铲屎官小李',
      role: '宠物博主',
      avatar: '🐶'
    },
    likes: 0,
    views: 0,
    comments: 0,
    content: '（草稿内容：狗狗摇尾巴不一定是开心，可能是紧张...）',
    status: 'draft', // 新增：草稿状态
    createdAt: '2026-01-10T09:15:00Z',
    updatedAt: '2026-01-10T10:20:00Z'
  }
];

// 新增：用户个人信息（适配个人中心）
export const MOCK_USER_INFO = {
  id: 1,
  name: '咖啡喵',
  nickname: '咖啡喵',
  avatar: '🐱',
  bio: '热爱生活，喜欢记录生活中的美好瞬间。相信每一天都有值得感恩的小确幸。',
  role: '生活博主',
  stats: {
    posts: 4, // 已发布文章数
    drafts: 1, // 草稿数
    views: 8076, // 总阅读量
    likes: 807 // 总获赞数
  }
};

// 数据操作函数（模拟接口逻辑）
let posts = [...MOCK_POSTS, ...defaultPostsData];

export const incrementViewCount = (postId) => {
  const post = posts.find(p => p.id === postId);
  if (post) {
    post.views += 1;
    triggerDataChange(postId);
    return post.views;
  }
  return 0;
};

export const likePost = (postId) => {
  const post = posts.find(p => p.id === postId);
  if (post) {
    post.likes += 1;
    triggerDataChange(postId);
    return post.likes;
  }
  return 0;
};

export const unlikePost = (postId) => {
  const post = posts.find(p => p.id === postId);
  if (post && post.likes > 0) {
    post.likes -= 1;
    triggerDataChange(postId);
    return post.likes;
  }
  return 0;
};

export const getPostById = (postId) => {
  return posts.find(p => p.id === postId) || null;
};

const triggerDataChange = (postId) => {
  window.dispatchEvent(new CustomEvent('blogDataChanged', {
    detail: { postId }
  }));
};

// 新增：获取当前用户的文章（按状态筛选）
export const getMyPosts = (userId, status = '') => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // 筛选当前用户的文章
      let userPosts = posts.filter(post => post.author.id === userId);
      // 按状态筛选（空字符串返回全部）
      if (status) {
        userPosts = userPosts.filter(post => post.status === status);
      }
      // 按更新时间倒序排列
      userPosts.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      resolve(userPosts);
    }, 300);
  });
};

// 新增：保存草稿
export const saveDraft = (postData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newPost = {
        ...postData,
        status: 'draft',
        published: false,
        views: 0,
        likes: 0,
        comments: 0,
        createdAt: postData.createdAt || new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        id: postData.id || Date.now() // 新草稿用时间戳做ID
      };
      // 更新或新增草稿
      const index = posts.findIndex(p => p.id === newPost.id);
      if (index > -1) {
        posts[index] = newPost;
      } else {
        posts.push(newPost);
      }
      triggerDataChange(newPost.id);
      resolve(newPost);
    }, 300);
  });
};

// 新增：发布文章（从草稿转为已发布）
export const publishPost = (postId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const post = posts.find(p => p.id === postId);
      if (post) {
        post.status = 'published';
        post.published = true;
        post.updatedAt = new Date().toISOString();
        post.date = new Date().toLocaleDateString(); // 更新发布日期
        triggerDataChange(postId);
      }
      resolve(post || null);
    }, 300);
  });
};

// 新增：删除文章（支持草稿和已发布）
export const deletePost = (postId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const index = posts.findIndex(p => p.id === postId);
      if (index > -1) {
        posts.splice(index, 1);
        triggerDataChange(postId);
        resolve({ success: true });
      } else {
        resolve({ success: false, message: '文章不存在' });
      }
    }, 300);
  });
};

// 新增：更新文章内容
export const updatePost = (postId, updateData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const post = posts.find(p => p.id === postId);
      if (post) {
        const updatedPost = {
          ...post,
          ...updateData,
          updatedAt: new Date().toISOString()
        };
        posts[posts.findIndex(p => p.id === postId)] = updatedPost;
        triggerDataChange(postId);
        resolve(updatedPost);
      } else {
        resolve(null);
      }
    }, 300);
  });
};

// 新增：获取用户统计数据
export const getUserStats = (userId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const userPosts = posts.filter(post => post.author.id === userId);
      const stats = {
        posts: userPosts.filter(p => p.status === 'published').length,
        drafts: userPosts.filter(p => p.status === 'draft').length,
        views: userPosts.reduce((sum, post) => sum + post.views, 0),
        likes: userPosts.reduce((sum, post) => sum + post.likes, 0)
      };
      resolve(stats);
    }, 300);
  });
};

// 首页相关模拟数据
export const MOCK_HOME_DATA = {
  // 每日语录列表
  QUOTES: [
    { text: "生活不是等待暴风雨过去，而是学会在雨中跳舞。", author: "佚名" },
    { text: "每一天都是新的开始，不要因为昨天而错过今天的美好。", author: "小狗日志" },
    { text: "真正的成长是在平凡的日子里找到不平凡的自己。", author: "咖啡喵" },
    { text: "用心记录生活，用爱温暖他人。", author: "旅行猫" },
    { text: "代码如诗，生活如画，二者都要用心经营。", author: "代码狗" },
    { text: "最好的写作灵感来源于最真实的生活体验。", author: "书虫君" }
  ],

  // 推荐作者信息
  AUTHOR_INFO: {
    name: "咖啡喵",
    role: "生活博主 | 最受欢迎作者",
    bio: "热爱生活，喜欢记录生活中的美好瞬间。相信每一天都有值得感恩的小确幸。",
    stats: {
      posts: 4,
      views: 8076,
      likes: 807
    },
    achievements: ["⭐ 最受欢迎作者", "🏆 月度最佳博主", "🎖️ 连续3周热门作者"]
  },

  // 首页配置项
  CONFIG: {
    DEFAULT_PAGE_SIZE: 6, // 首页默认展示文章数
    HOT_SEARCH_TAGS: ['生活', '技术', '旅行', '读书', 'React', '小狗'], // 热门搜索标签
    EMPTY_POSTS_TEXT: '暂时还没有文章',
    EMPTY_POSTS_SUBTEXT: '快来发表你的第一篇文章吧！',
    NO_SEARCH_RESULTS_TEXT: '没有找到相关文章',
    NO_SEARCH_RESULTS_SUBTEXT: '尝试使用不同的关键词搜索',
    LOADING_POSTS_TEXT: '正在加载文章...',
    LOADING_SEARCH_TEXT: '正在搜索文章...',
    WRITE_CARD_TITLE: '有想法要分享？',
    WRITE_CARD_SUBTEXT: '记录你的思考，分享你的故事，让更多人看到你的文字。',
    FOLLOW_AUTHOR_TEXT: {
      follow: '关注作者',
      following: '已关注'
    },
    QUOTE_TITLE: '今日小狗语录',
    QUOTE_SWITCH_TEXT: '换一句',
    VIEW_ALL_ARCHIVE_TEXT: '查看归档',
    WRITE_NOW_TEXT: '立即创作'
  },

  // 分类图标
  CATEGORY_ICONS: {
    '生活随笔': '📝',
    '技术分享': '💻',
    '读书笔记': '📚',
    '旅行日记': '✈️',
    '个人成长': '🌱',
    '美食分享': '🍽️',
    '宠物养护': '🐾',
    '宠物知识': '🐶',
    '全部': '📊' // 新增全部分类图标
  },
  DEFAULT_CATEGORY_ICON: '📄'
};

// 文章详情页相关模拟数据
export const MOCK_POST_DETAIL_DATA = {
  // 模拟评论数据
  DEFAULT_COMMENTS: [
    {
      id: 1,
      author: '阳光旅行者',
      avatar: '🧳',
      content: '太喜欢这篇文章了！让我想起了在京都看到的清晨阳光。',
      date: '2024-03-15 09:30',
      likes: 12
    },
    {
      id: 2,
      author: '思考者',
      avatar: '🤔',
      content: '早晨的宁静时光确实最适合思考，感谢分享这么美好的体验。',
      date: '2024-03-15 10:15',
      likes: 8
    }
  ],

  // 配置项/默认值
  CONFIG: {
    AUTHOR_FOLLOWERS_MIN: 100, // 作者粉丝数最小值
    AUTHOR_FOLLOWERS_MAX: 600, // 作者粉丝数最大值
    RELATED_POSTS_LIMIT: 3,    // 相关文章展示数量
    MAX_COMMENTS_DISPLAY: 3,   // 最大展示评论数
    DEFAULT_READ_TIME: 5,      // 默认阅读时长
    LOCAL_STORAGE_KEYS: {      // 本地存储key
      likedPosts: 'blog_liked_posts',
      bookmarks: 'blog_bookmarks',
      following: 'blog_following'
    }
  },

  // 静态文本/提示
  TEXT: {
    LOADING: {
      main: '正在嗅嗅文章内容...',
      dogIcon: '🐕',
      pawTrail: ['🐾', '🐾', '🐾']
    },
    POST_NOT_FOUND: {
      title: '🐕 文章走丢了！',
      subtext: '没有找到这篇文章，可能它正在其他地方玩耍。',
      btnText: '返回首页'
    },
    EMPTY_CONTENT: '文章内容加载中...',
    EMPTY_RELATED_POSTS: '暂无相关文章',
    COMMENT_PLACEHOLDER: '分享你的想法...',
    COMMENT_SUBMIT_BTN: '发表评论',
    COMMENT_SUCCESS: '评论发表成功！',
    BOOKMARK: {
      add: '文章已收藏！',
      remove: '已取消收藏'
    },
    FOLLOW: {
      add: (name) => `已关注 ${name}！`,
      remove: (name) => `已取消关注 ${name}`
    },
    SHARE: {
      copySuccess: '文章链接已复制到剪贴板！',
      tip: '分享给更多人看到这篇精彩文章吧！',
      twitter: 'Twitter',
      weibo: '微博',
      copy: '复制链接'
    },
    DIRECTORY: {
      title: '📑 目录',
      items: [
        { id: 'section1', text: '文章摘要' },
        { id: 'section2', text: '详细内容' },
        { id: 'section3', text: '思考分享' },
        { id: 'section4', text: '结语' }
      ]
    },
    RELATED_POSTS_TITLE: '📚 相关文章',
    SHARE_CARD_TITLE: '📤 分享文章',
    COMMENTS_TITLE: '💬 评论',
    BACK_BTN_TEXT: '← 返回',
    UNKNOWN_AUTHOR: '未知作者',
    AUTHOR_FOLLOWERS_LABEL: '粉丝'
  },

  // 图标配置
  ICONS: {
    date: '📅',
    time: '⏱️',
    view: '👁️',
    like: { active: '❤️', inactive: '🤍' },
    comment: '💬',
    share: '📤',
    bookmark: { active: '🔖', inactive: '📑' },
    follow: { active: '✅', inactive: '➕' },
    avatar: '👤',
    twitter: '🐦',
    weibo: '💬',
    copy: '📋',
    commentLike: '❤️'
  }
};

// 新增：补充 postsData 中缺失的方法（PostDetail 用到的）
export const getRelatedPosts = (postId, limit) => {
  // 过滤当前文章，取其他文章作为相关推荐
  return MOCK_POSTS.filter(post => post.id !== postId).slice(0, limit);
};

export const addCommentCount = (postId) => {
  const post = MOCK_POSTS.find(p => p.id === postId);
  if (post) {
    post.comments = (post.comments || 0) + 1;
    triggerDataChange(postId);
    return post.comments;
  }
  return 0;
};

// 获取已点赞文章函数：
export const getLikedPosts = () => {
  const likedPostsStr = localStorage.getItem(MOCK_POST_DETAIL_DATA.CONFIG.LOCAL_STORAGE_KEYS.likedPosts) || '[]';
  return JSON.parse(likedPostsStr);
};